module.exports = __webpack_public_path__ + "static/img/CC-0.0c97ae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cc/CC-0.png
// module id = fWCF
// module chunks = 16